// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../Assets/selectArrow.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../Assets//selectArrow.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cursor-pointer{
cursor:pointer;
}
.error-class{
  color:red;
  font-size: 12px;
}
.tabulate-select option:disabled {
  color:rgb(168, 159, 159); 
  background-color: #f5f5f5; 
}

.competitor-count {
  padding: 0px 6px;
  background: #fbb040;
  border-radius: 4px;
  font-size: 16px;
  color: #ffffff;
}
.search-label {
  font-weight: 500;
  font-size: 12px;
  color: #000000;
  margin-left: 5px;
  margin-bottom: 2px;
  width: 100%;
}
.searchFeisComp,
.searchFeisComps {
  width: 248px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #797979;
  border-radius: 4px;
  padding: 10px;
}
.searchFeisComps {
  width: 340px;
}
.searchFeisCompsSelect {
  width: 340px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #797979;
  border-radius: 4px;
  outline: none;
}
input.searchFeisComp {
  outline: none;
}
.org-body-white {
  padding: 0 7%;
}
.ql-editor {
  background: white !important;
  padding: 20px !important;
  height: 100px !important;
}
.ql-snow.ql-toolbar button {
  border-radius: 0;
  box-shadow: none;
  margin-top: 0;
}
.feis-manage {
  font-size: 14px;
  color: #424242;
}
.email-msg {
  border: 1px solid #797979;
  background: #ffffff;
  border-radius: 4px;
}
.text-area {
  border: none;
  outline: none;
  border-radius: 4px;
  resize: none;
  min-height: 150px;
  width: 100%;
  padding: 10px 10px 0 10px;
}
.text-area::-webkit-scrollbar {
  display: none;
}
.check-in-select {
  border-radius: 4px;
  border: 1px solid #797979;
  background: #fff;
  width: 311px;
  -webkit-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 15px 8px !important;
  background-repeat: no-repeat;
  background-size: 4%;
  background-position: top 50% right 6%;
}
.check-in-input{
  border-radius: 4px;
  border: 1px solid #797979;
  background: #fff;
  width: 311px; 
  -webkit-appearance: none;
padding:9px
}
.edit-register-org {
  background-image: linear-gradient(
    to right,
    #fff 0%,
    #fff 50%,
    #fff 50%,
    #fafafa 72%
  );
  padding: 0 7%;
}
.wrap-select {
  width: calc(33.33% - 12px); 
  height: 60px;
  border-radius: 4px;
}

.wrap-select-with-round {
  width: calc(25% - 16px);
  height: 60px;
  border-radius: 4px;
}
.tabulate-select-div {
  display: flex;
  flex-wrap: wrap;
  column-gap: 18px;
}

.tabulate-select {
  border-radius: 4px;
  border: 1px solid #797979;
  background: #fff;
  width: 100%;
  -webkit-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: 15px 8px !important;
  background-repeat: no-repeat;
  background-size: 4%;
  background-position: top 50% right 6%;
}
.tabulate-input{
  border-radius: 4px;
  border: 1px solid #797979;
  background: #fff;
  width: 100%;
  padding:9px;
  -webkit-appearance: none;
}
.input-code {
  height: 40px;
  width: 100%;
  border: 1px solid #797979;
  border-radius: 4px;
}
.input-desc {
  height: 80px;
  width: 100%;
  border: 1px solid #797979;
  border-radius: 4px;
}
.input-code input {
  width: 100%;
  height: 100%;
  padding: 5px;
  border-radius: 4px;
  border: none;
  resize: none; 
  outline: none; 
}

.table-text-area {
  border: none;
  outline: none;
  border-radius: 4px;
  resize: none;
  min-height: 100%;
  width: 100%;
  padding: 5px;
}
.input-code input {
  text-align: center;
}
.transaction-card {
  border-radius: 4px;
  background: #ffffff;
  box-shadow: 0px 5px 22px 0px rgba(0, 0, 0, 0.05);
  height: 80px;
}
.custom-select:focus {
  border-color: #797979 !important;
}

.visibleErr{
  visibility:visible;
  color:red;
  font-size: 12px;
}
.invisible{
  visibility:hidden;
}
@media only screen and (min-width: 0px) and (max-width: 480px) {
  .searchFeisComp {
    width: 100%;
  }
  .searchFeisCompsSelect {
    width: 100%;
  }
  .searchFeisComp::placeholder {
    font-size: 10px;
  }
  .org-body-white {
    padding: 0 5%;
  }
  .edit-register-org {
    background-image: none;
    padding: 0;
  }
  .editOrg-leftDiv,
  .editOrg-rightDiv {
    padding: 0 5% !important;
  }
  .tabulate-select-div {
    flex-direction: column;
  }
  .tabulate-select {
    width: 311px;
  }
  .wrap-select {
    margin-top: 5px;
  }
  .wrap-select-with-round {
width:auto;
  }
}
@media only screen and (min-width: 481px) and (max-width: 767px) {
  .searchFeisComp {
    width: 340px;
  }
  .org-body-white {
    padding: 0 5%;
  }
  .edit-register-org {
    background-image: none;
    padding: 0;
  }
  .editOrg-leftDiv,
  .editOrg-rightDiv {
    padding: 0 5% !important;
  }
  .tabulate-select-div {
    display: block;
  }
  .tabulate-select {
    width: 311px;
  }
  .wrap-select {
    margin-top: 1rem;
  }
  .wrap-select-with-round {
    width:auto;
      }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .check-in-select {
    width: 250px;
  }
  .check-in-input {
    width: 250px;
  }
  .org-body-white {
    padding: 0 7%;
  }
  .edit-register-org {
    padding: 0 7%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Organizer/ManageFeisGrade/RedirectFeis/FeisCompetitor.css"],"names":[],"mappings":"AAAA;AACA,cAAc;AACd;AACA;EACE,SAAS;EACT,eAAe;AACjB;AACA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;AACA;;EAEE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,yDAAwD;EACxD,oCAAoC;EACpC,4BAA4B;EAC5B,mBAAmB;EACnB,qCAAqC;AACvC;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;AAC1B;AACA;AACA;EACE;;;;;;GAMC;EACD,aAAa;AACf;AACA;EACE,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,wBAAwB;EACxB,yDAAyD;EACzD,oCAAoC;EACpC,4BAA4B;EAC5B,mBAAmB;EACnB,qCAAqC;AACvC;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gDAAgD;EAChD,YAAY;AACd;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,UAAU;EACZ;EACA;;IAEE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;AACF,UAAU;EACR;AACF;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,UAAU;EACZ;EACA;;IAEE,wBAAwB;EAC1B;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;EACA;IACE,UAAU;MACR;AACN;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF","sourcesContent":[".cursor-pointer{\ncursor:pointer;\n}\n.error-class{\n  color:red;\n  font-size: 12px;\n}\n.tabulate-select option:disabled {\n  color:rgb(168, 159, 159); \n  background-color: #f5f5f5; \n}\n\n.competitor-count {\n  padding: 0px 6px;\n  background: #fbb040;\n  border-radius: 4px;\n  font-size: 16px;\n  color: #ffffff;\n}\n.search-label {\n  font-weight: 500;\n  font-size: 12px;\n  color: #000000;\n  margin-left: 5px;\n  margin-bottom: 2px;\n  width: 100%;\n}\n.searchFeisComp,\n.searchFeisComps {\n  width: 248px;\n  height: 40px;\n  background: #ffffff;\n  border: 1px solid #797979;\n  border-radius: 4px;\n  padding: 10px;\n}\n.searchFeisComps {\n  width: 340px;\n}\n.searchFeisCompsSelect {\n  width: 340px;\n  height: 40px;\n  background: #ffffff;\n  border: 1px solid #797979;\n  border-radius: 4px;\n  outline: none;\n}\ninput.searchFeisComp {\n  outline: none;\n}\n.org-body-white {\n  padding: 0 7%;\n}\n.ql-editor {\n  background: white !important;\n  padding: 20px !important;\n  height: 100px !important;\n}\n.ql-snow.ql-toolbar button {\n  border-radius: 0;\n  box-shadow: none;\n  margin-top: 0;\n}\n.feis-manage {\n  font-size: 14px;\n  color: #424242;\n}\n.email-msg {\n  border: 1px solid #797979;\n  background: #ffffff;\n  border-radius: 4px;\n}\n.text-area {\n  border: none;\n  outline: none;\n  border-radius: 4px;\n  resize: none;\n  min-height: 150px;\n  width: 100%;\n  padding: 10px 10px 0 10px;\n}\n.text-area::-webkit-scrollbar {\n  display: none;\n}\n.check-in-select {\n  border-radius: 4px;\n  border: 1px solid #797979;\n  background: #fff;\n  width: 311px;\n  -webkit-appearance: none;\n  background-image: url('../../../Assets/selectArrow.png');\n  background-size: 15px 8px !important;\n  background-repeat: no-repeat;\n  background-size: 4%;\n  background-position: top 50% right 6%;\n}\n.check-in-input{\n  border-radius: 4px;\n  border: 1px solid #797979;\n  background: #fff;\n  width: 311px; \n  -webkit-appearance: none;\npadding:9px\n}\n.edit-register-org {\n  background-image: linear-gradient(\n    to right,\n    #fff 0%,\n    #fff 50%,\n    #fff 50%,\n    #fafafa 72%\n  );\n  padding: 0 7%;\n}\n.wrap-select {\n  width: calc(33.33% - 12px); \n  height: 60px;\n  border-radius: 4px;\n}\n\n.wrap-select-with-round {\n  width: calc(25% - 16px);\n  height: 60px;\n  border-radius: 4px;\n}\n.tabulate-select-div {\n  display: flex;\n  flex-wrap: wrap;\n  column-gap: 18px;\n}\n\n.tabulate-select {\n  border-radius: 4px;\n  border: 1px solid #797979;\n  background: #fff;\n  width: 100%;\n  -webkit-appearance: none;\n  background-image: url('../../../Assets//selectArrow.png');\n  background-size: 15px 8px !important;\n  background-repeat: no-repeat;\n  background-size: 4%;\n  background-position: top 50% right 6%;\n}\n.tabulate-input{\n  border-radius: 4px;\n  border: 1px solid #797979;\n  background: #fff;\n  width: 100%;\n  padding:9px;\n  -webkit-appearance: none;\n}\n.input-code {\n  height: 40px;\n  width: 100%;\n  border: 1px solid #797979;\n  border-radius: 4px;\n}\n.input-desc {\n  height: 80px;\n  width: 100%;\n  border: 1px solid #797979;\n  border-radius: 4px;\n}\n.input-code input {\n  width: 100%;\n  height: 100%;\n  padding: 5px;\n  border-radius: 4px;\n  border: none;\n  resize: none; \n  outline: none; \n}\n\n.table-text-area {\n  border: none;\n  outline: none;\n  border-radius: 4px;\n  resize: none;\n  min-height: 100%;\n  width: 100%;\n  padding: 5px;\n}\n.input-code input {\n  text-align: center;\n}\n.transaction-card {\n  border-radius: 4px;\n  background: #ffffff;\n  box-shadow: 0px 5px 22px 0px rgba(0, 0, 0, 0.05);\n  height: 80px;\n}\n.custom-select:focus {\n  border-color: #797979 !important;\n}\n\n.visibleErr{\n  visibility:visible;\n  color:red;\n  font-size: 12px;\n}\n.invisible{\n  visibility:hidden;\n}\n@media only screen and (min-width: 0px) and (max-width: 480px) {\n  .searchFeisComp {\n    width: 100%;\n  }\n  .searchFeisCompsSelect {\n    width: 100%;\n  }\n  .searchFeisComp::placeholder {\n    font-size: 10px;\n  }\n  .org-body-white {\n    padding: 0 5%;\n  }\n  .edit-register-org {\n    background-image: none;\n    padding: 0;\n  }\n  .editOrg-leftDiv,\n  .editOrg-rightDiv {\n    padding: 0 5% !important;\n  }\n  .tabulate-select-div {\n    flex-direction: column;\n  }\n  .tabulate-select {\n    width: 311px;\n  }\n  .wrap-select {\n    margin-top: 5px;\n  }\n  .wrap-select-with-round {\nwidth:auto;\n  }\n}\n@media only screen and (min-width: 481px) and (max-width: 767px) {\n  .searchFeisComp {\n    width: 340px;\n  }\n  .org-body-white {\n    padding: 0 5%;\n  }\n  .edit-register-org {\n    background-image: none;\n    padding: 0;\n  }\n  .editOrg-leftDiv,\n  .editOrg-rightDiv {\n    padding: 0 5% !important;\n  }\n  .tabulate-select-div {\n    display: block;\n  }\n  .tabulate-select {\n    width: 311px;\n  }\n  .wrap-select {\n    margin-top: 1rem;\n  }\n  .wrap-select-with-round {\n    width:auto;\n      }\n}\n@media only screen and (min-width: 768px) and (max-width: 1024px) {\n  .check-in-select {\n    width: 250px;\n  }\n  .check-in-input {\n    width: 250px;\n  }\n  .org-body-white {\n    padding: 0 7%;\n  }\n  .edit-register-org {\n    padding: 0 7%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
